export const FIND_SECONDARY_PRODUCTS_QUERY = gql`
    query FindSecondaryProducts($ids: [ID]!) {
        findSecondaryProducts(ids: $ids) {
            id
            name
            type
            catalogue
            imageUrl
            term
            connectivity
        }
    }
`;

export const GET_PRICING_OFFERS_BY_TYPE = gql`
    query GetPricingOffersByType($input: FilterPricingOffersInput!) {
        getPricingOffersByType(input: $input) {
            total
            page
            pageSize
            data {
                id
                name
                partners {
                    id
                    firstName
                    lastName
                    business {
                        legalName
                    }
                }
                partnersOfPartner {
                    id
                    business {
                        id
                    }
                }
                assigned_total
                status
                legacyAt
                createdAt
            }
        }
    }
`;

export const GET_PRICING_OFFER = gql`
    query GetPricingOffer($id: Int!) {
        offer(id: $id) {
            id
            name
            term
            customTerm
            type
            status
            partners {
                id
                firstName
                lastName
                business {
                    legalName
                }
            }
            primaryProducts {
                id
                name
                catalogue
                type
                imageUrl
                secondaryProductIds
            }
            secondaryProducts {
                id
                name
                catalogue
                type
                imageUrl
            }
            pricings {
                type
                catalogue
                product {
                    id
                    name
                    catalogue
                    type
                    imageUrl
                }
                prices {
                    type
                    oneOff {
                        lowest
                        highest
                    }
                    monthly {
                        lowest
                        highest
                    }
                    options {
                        oneOff {
                            sales
                            commission
                        }
                        monthly {
                            sales
                            commission
                        }
                    }
                }
            }
            salesConditions
            gpvConditions
            gpvLowest
            gpvHighest
            mccConditions
            promos {
                id
                productId
                offerId
                applyPromo
            }
            mccs {
                id
                code
                name
            }
        }
    }
`;

export const GET_PRICING_OFFERS = gql`
    query PricingOffers($filter: FilterPricingOffersForMerchantInput) {
        pricingOffers(filter: $filter) {
            name
            id
            salesConditions
            mccConditions
            gpvConditions
            gpvLowest
            gpvHighest
            promos {
                id
                productId
                offerId
                applyPromo
            }
            legacyAt
            primaryProducts {
                id
                name
                imageUrl
            }
            secondaryProducts {
                id
                imageUrl
                name
            }
            pricings {
                id
                name
                cost
                npiBuildPrice
                partnerBuidlPrice
                name
                type
                term
                product {
                    id
                    type
                    catalogue
                }
                pciComplianceFeeProgramme
                pciComplianceRate
                safePayNonComplianceChargeBase
                safePayNonComplianceChargeHighest
                safePayNonComplianceChargeLowest
                safePayVulnerabilityScanFeeBase
                safePayVulnerabilityScanFeeLowest
                safePayVulnerabilityScanFeeHighest
                safePayServiceFeeBase
                safePayServiceFeeLowest
                safePayServiceFeeHighest
                catalogue
                prices {
                    oneOff {
                        lowest
                        highest
                    }
                    monthly {
                        lowest
                        highest
                    }
                    options {
                        oneOff {
                            sales
                            commission
                        }
                        monthly {
                            sales
                            commission
                        }
                    }
                }
            }
        }
    }
`;
